// extracted by mini-css-extract-plugin
export default {"chip":"Chip-module__chip--vyToL"};